import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../../services/AuthService';
import { isExtension } from '../../utils/tokenUtils';

export const getAPIPath = async (): Promise<string | undefined> => {
  if (!isExtension) {
    return (process.env.API_URL || window.location.host)
      ?.replace('https://', '')
      .replace('http://', '');
  }

  const authService = AuthService.getInstance();
  const token =
    (await authService.getAuthToken()) || (await authService.getRefreshToken());

  if (!token) {
    return undefined;
  }

  const decodedToken = jwtDecode(token) as { iss: string };
  return decodedToken.iss;
};
